import * as actionTypes from "./CustomersTypes";

const INITIAL_STATE = {
    countryList: [],
    customerDetail: null,
    customerList: [],
    allContactPersonList: [],
    customerFilterList: [],
    basicFilterData: [],
    customerTypeList: []
};

const CustomerDetailsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCOUNTRYLIST:
            return {
                ...state,
                countryList: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                customerDetail: null
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customerList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERFILTERLIST:
            return {
                ...state,
                customerFilterList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERDETAIL:
            return {
                ...state,
                customerDetail: action.payload.list,
            };
        case actionTypes.SETALLCONTACTPERSONLIST:
            return {
                ...state,
                allContactPersonList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        case actionTypes.SETCUSTOMERTYPELIST:
            return {
                ...state,
                customerTypeList: action.payload.list,
            };
        default:
            return state;
    }
};

export default CustomerDetailsReducer;